 <template>
  <div class="SettingsModal">
    <b-modal id="modal-1" ok-title="Bezár" ok-only title="Személyes beállítások">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Adataim" active><div>
            <div>
              <b-form  @submit.stop.prevent>
                <label for="firstname">Vezetéknév</label>
                <b-input type="text" v-model="lastname" :state="validationLastnameNot" id="lastname"></b-input>
                <b-form-invalid-feedback :state="validationLastnameNot">
                  
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validationLastnameNot">
                  Elfogadva
                </b-form-valid-feedback>
                <label for="firstname">Keresztnév</label>
                <b-input type="text" v-model="firstname" :state="validationFirstnameNot" id="firstname"></b-input>
                <b-form-invalid-feedback :state="validationFirstnameNot">
                  
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validationFirstnameNot">
                  Elfogadva
                </b-form-valid-feedback>
                <label for="email">Email</label>
                <b-input type="email" v-model="email" :state="validationEmail" id="email"></b-input>
                <b-form-invalid-feedback :state="validationEmail">
                  
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validationEmail">
                  Elfogadva
                </b-form-valid-feedback>
                <label for="phone">Telefonszám</label>
                <b-input type="text" v-model="phone" :state="validationPhone" id="phone"></b-input>
                <b-form-invalid-feedback :state="validationPhone">
                  
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validationPhone">
                  Elfogadva
                </b-form-valid-feedback>
                <b-button class="mt-2" v-on:click="updateUserData()" variant="success">Mentés</b-button>
              </b-form>
            </div>
            </div>
          </b-tab>
          <b-tab title="Jelszó változtatás">
            <div>
              <b-form  @submit.stop.prevent>
                <label for="password-change">Új jelszó</label>
                <b-input type="password" v-model="password" :state="validation" id="password-change"></b-input>
                <b-form-invalid-feedback :state="validation">
                  A jelszónak legalább 8 karakter hosszúnak kell lennie!
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="validation">
                  Megfelelő jelszó
                </b-form-valid-feedback>
                <b-button class="mt-2" v-on:click="updatePassword()" variant="success">Mentés</b-button>
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SettingsModal',
  data() {
      return {
        password: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
      }
    },
    computed: {
      validation() {
        return this.password.length > 7
      },
      validationRe() {
        return this.passwordre == this.password
      },
      validationFirstnameNot(){
        return this.firstname != ""
      },
      validationLastnameNot(){
        return this.lastname != ""
      },
      validationEmail(){
        return this.email != ""
      },
      validationPhone(){
        return this.phone != ""
      },
    },
    methods:{
      updatePassword(){
        if(this.password.length > 7){
          const params = new URLSearchParams();
          params.append('updatePassword', true);
          params.append('password', this.password);
          params.append('user_id', this.$session.get('id'));
          axios({
            method: 'post',
            url: process.env.VUE_APP_PROFILE_API,
            data:params
          }).then(() => {
          this.$swal('Sikeresen frissítve', 'Most már újonnan kapott jelszavaddal lesz lehetőséged bejelentkezni.', 'success');
          });
        }else{
          this.$swal('Hiba történt', 'A megadott jelszó nem elég hosszú. Legalább 8 karakter hosszú jelszót szükséges megadni!', 'error');
        }
      },
      updateUserData(){
        if(this.firstname == "" || this.lastname == "" || this.email == "" || this.phone == ""){
          this.$swal('Hiba történt', 'Minden mező kitöltése kötelező!', 'error');
        }else{
          const params = new URLSearchParams();
          params.append('updateData', true);
          params.append('firstname', this.firstname);
          params.append('lastname', this.lastname);
          params.append('email', this.email);
          params.append('phone', this.phone);
          params.append('user_id', this.$session.get('id'));
          axios({
            method: 'post',
            url: process.env.VUE_APP_PROFILE_API,
            data:params
          }).then(() => {
              this.$swal('Sikeresen frissítve', 'Most már az alábbi adatokkal leszel jelen a rendszerben.', 'success');
          });
        }
      },
    },
    mounted(){
      const params = new URLSearchParams();
      params.append('getData', true);
      params.append('user_id', this.$session.get('id'));
      axios({
        method: 'post',
        url: process.env.VUE_APP_PROFILE_API,
        data:params
      }).then((response) => {
        this.firstname = response.data[0].firstname
        this.lastname = response.data[0].lastname
        this.email = response.data[0].email
        this.phone = response.data[0].phone
      })
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
b-tab{
  color:magenta !important;
}
</style>
